import axiosInstance from 'services/axiosMiddleware';

export async function useLibraryAsanas(libraryDatas) {
  try {
    const response = await axiosInstance.post('libraryasana/createLibraryAsanas', libraryDatas);
    console.log('response', response);
    return response;
  } catch (error) {
    console.error('Error fetching Asana data:', error);
    throw error;
  }
}
